module.exports = __webpack_public_path__ + "img/increased_reach.a723a974.svg";